import { KYMW1800Component } from './kymw1800.component';

/**
 * 画像ﾁｪｯｸﾘｽﾄ出力画面の値を管理するクラス
 *
 * @export KYMW1800Model
 * @class KYMW1800Model
 */
export class KYMW1800Model {

  KYMW1800Component: KYMW1800Component;

  // ファイル名
  public fileName: string = <string> '';
  /** 受注コード */
  public orderCode: string = <string> '';
  /** 媒体 */
  public mediumType: string = <string> '';
  /** 出力リスト */
  public outputType: string = <string> '';
  public ibaraki: boolean = <boolean> false;
  public tochigi: boolean = <boolean> false;
  public gunma: boolean = <boolean> false;
  public chiba: boolean = <boolean> false;
  public saitama: boolean = <boolean> false;
  public tokyo: boolean = <boolean> false;
  public nagano: boolean = <boolean> false;
  public niigata: boolean = <boolean> false;
  public kuruco: boolean = <boolean> false;

  /**
   * ファイル名を更新する
   *
   * @param serverData ファイル名のサーバ取得データ
   */
  public updateFileName(serverData: any) {
    this.fileName = serverData.FileName;
  }

}
